import { SCOPE_ROWS } from "@/frontend/constants/oauth-scopes";
import type { ScopeRow } from "@/frontend/types/oauth";

/** The consent rows a granted scope list covers (label + description), in display order. */
export function grantedScopeRows(scopes: string[]): ScopeRow[] {
  const granted = new Set(scopes);
  return SCOPE_ROWS.filter((row) => row.scopes.some((s) => granted.has(s)));
}

/** Renders a granted scope list as the friendly consent-row labels. */
export function scopeRowLabels(scopes: string[]): string[] {
  return grantedScopeRows(scopes).map((row) => row.label);
}
